import { useSearchParams } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import Breadcrumbs from "../../../components/breadcrumbs";
import ShoppingCompanyService from "../../../services/ShoppingCompanyService";
import ShoppingCompany from "../../../models/ShoppingCompany";
import { CreateShoppingCompany } from "./ui/buttons";
import ShoppingCompaniesTable from "./ui/shopping-companies-table";
import ShoppingCompaniesSkeleton from "./skeleton/shopping-companies-skeleton";

export default function ShoppingCompaniesPage() {
  const [searchParams] = useSearchParams();
  const reload = searchParams.get("reload");
  const [items, setItems] = useState<ShoppingCompany[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchItems = useCallback(async () => {
    const api = new ShoppingCompanyService();
    try {
      const data = await api.getShoppingCompanies();
      setItems(data);
    } catch (error) {
      console.error("Error fetching shopping companies:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void fetchItems();
  }, [fetchItems, reload]);

  return (
    <div className="w-full">
      <Breadcrumbs
        breadcrumbs={[
          { label: "Shopping Companies", href: "/admin/shopping-companies" },
        ]}
      />
      <CreateShoppingCompany />
      {loading ? (
        <ShoppingCompaniesSkeleton />
      ) : (
        <ShoppingCompaniesTable items={items} />
      )}
    </div>
  );
}
